import { render, staticRenderFns } from "./NsMinimalHeaderRegionSelector.vue?vue&type=template&id=41970266&scoped=true&"
import script from "./NsMinimalHeaderRegionSelector.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderRegionSelector.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderRegionSelector.vue?vue&type=style&index=0&id=41970266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41970266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41970266')) {
      api.createRecord('41970266', component.options)
    } else {
      api.reload('41970266', component.options)
    }
    module.hot.accept("./NsMinimalHeaderRegionSelector.vue?vue&type=template&id=41970266&scoped=true&", function () {
      api.rerender('41970266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/MinimalHeader/NsMinimalHeaderRegionSelector.vue"
export default component.exports